import React from 'react';
import { Typography } from '@material-ui/core';
import { styled } from '@material-ui/core/styles';

export const HomeH2Variant = ['themeColor', 'white'] as const;

export type HomeH2VariantType = typeof HomeH2Variant[number];

export interface HomeH2Props {
  variant?: HomeH2VariantType;
  className?: string;
  children?: string | JSX.Element | JSX.Element[];
}

export const HomeH2 = React.memo(
  ({ variant = 'themeColor', children = '', ...props }: HomeH2Props) => {
    const variantColor = (() => {
      switch (variant) {
        case 'themeColor':
          return '#0EC6BD';
        case 'white':
          return '#ffffff';
        default:
          return '#0EC6BD';
      }
    })();

    const Component = styled(Typography)(({ theme }) => ({
      borderImage: `linear-gradient(to left, ${variantColor} calc(50% - 10px), transparent calc(50% - 10px), transparent calc(50% + 10px), ${variantColor} calc(50% + 10px)) 1/0 0 2px 0`,
      borderBottom: `2px solid ${variantColor}`,
      color: `${variantColor}`,
      fontSize: '28px',
      fontWeight: 'bold',
      lineHeight: '42px',
      position: 'relative',
      textAlign: 'center',
      width: '100%',
      maxWidth: '532px',
      '&:after': {
        bottom: '-6px',
        borderBottom: `2px solid ${variantColor}`,
        borderLeft: `2px solid ${variantColor}`,
        content: '""',
        left: 'calc(50% - 16px)',
        position: 'absolute',
        transform: 'rotate(-45deg)',
        transformOrigin: 'top right',
        height: '14px',
        width: '14px',
      },
    }));

    return (
      <Component variant="h2" {...props}>
        {children}
      </Component>
    );
  },
);
